export const PLANS = "PLANS";
export const ALL_PLANS = "ALL_PLANS";
